package com.devi3east.bashbuddy.ticketDetail.navigation

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.NavType
import androidx.navigation.compose.composable
import androidx.navigation.navArgument
import androidx.navigation.navDeepLink
import androidx.savedstate.read
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.data.api.BASE_URL
import com.devi3east.bashbuddy.ticketDetail.ui.TicketDetailRoute

const val TICKET_ID_ARG = "ticketId"

fun NavController.navigateToTicketDetail(
    ticketId: String,
    navOptions: NavOptions? = null
) {
    navigate(
        Screen.TicketDetailScreen.createRoute(ticketId),
        navOptions
    )
}

fun NavGraphBuilder.ticketDetailNavGraph(
    appState: AppState
) {
    composable(
        route = Screen.TicketDetailScreen.route,
        arguments = listOf(
            navArgument(TICKET_ID_ARG) {
                type = NavType.StringType
                nullable = false
            }
        ),
        deepLinks = listOf(
            navDeepLink {
                uriPattern =
                    "{$BASE_URL}/ticket/{$TICKET_ID_ARG}"
            }
        )
    ) { backStackEntry ->

        val args = backStackEntry.arguments ?: return@composable

        val ticketId = args.read {
            getString(TICKET_ID_ARG)
        }

        TicketDetailRoute(
            appState = appState,
            ticketId = ticketId
        )
    }
}